module.exports = __webpack_public_path__ + "static/media/bgShare1@3x.c13fb442.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/bgShare1@3x.png
// module id = 885
// module chunks = 0